/** @format */

export const CONTRACT_ADDRESS = "0x6d119824Eb9c06c02242FFFaB3A8F6775958032F";